// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_3-TabsCustomTitle_tabs_Zk6Td"};